// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const News: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 31 40" enableBackground="new 0 0 31 40" xmlSpace="preserve">
<path color="currentColor" fillRule="evenodd" clipRule="evenodd" d="M27.17,0H3.19C1.43,0,0,1.43,0,3.19v33.63C0,38.57,1.43,40,3.19,40h23.98
	c1.75,0,3.19-1.43,3.19-3.19V3.19C30.36,1.43,28.92,0,27.17,0z M3.95,6.33h11.22v2.29H3.95V6.33z M3.95,10.79h11.22v2.29H3.95V10.79
	z M3.95,15.26h11.22v2.29H3.95V15.26z M26.4,30.95H3.95v-2.29H26.4V30.95z M26.4,26.48H3.95v-2.29H26.4V26.48z M26.4,22.02H3.95
	v-2.29H26.4V22.02z M26.4,17.55h-9V6.33h9V17.55z"/>
</svg>;
};

export default React.memo(News);
